import {
    typeaheadConstants,
    typeaheadFulfilledConstants,
    typeaheadPendingConstants,
    typeaheadRejectedConstants
} from '../actions';

const initialState = {
    list: [],
    source: null,
    loading: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case typeaheadConstants.TYPEAHEAD_ADDED:
        case typeaheadFulfilledConstants.TYPEAHEAD_LOADED:
            return {
                ...state,
                list: action.payload.list,
                source: action.payload.source,
                loading: false
            };

        case typeaheadPendingConstants.TYPEAHEAD_LOADED:
            return {
                ...state,
                loading: true
            };
        case typeaheadConstants.TYPEAHEAD_CLEARED:
        case typeaheadRejectedConstants.TYPEAHEAD_LOADED:
            return {
                ...initialState
            };
        default:
            return state;
    }
}
